import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        rtwFieldLabel: {
            display: 'block',
            marginBottom: theme.spacing(0.5),
            fontSize: 14,
            fontWeight: 500,
            color: '#4D575E',
        },
        rtwRequiredMark: {
            color: '#D32F2F',
        },
        rtwCheckboxLabel: {
            color: '#4D575E',
            alignItems: 'center',
            marginLeft: 0,
            marginBottom: theme.spacing(1),
            '& .MuiCheckbox-root': {
                padding: 6,
            },
            '& .MuiFormControlLabel-label': {
                fontSize: 14,
                lineHeight: 1.4,
            },
        },
    }),
);
